import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'

const ScheduleCalendarHeaderRow: FC = () => {
  return (
    <tr className={styles.table__row}>
      <th className={styles.table__cell__header}>日</th>
      <th className={styles.table__cell__header}>月</th>
      <th className={styles.table__cell__header}>火</th>
      <th className={styles.table__cell__header}>水</th>
      <th className={styles.table__cell__header}>木</th>
      <th className={styles.table__cell__header}>金</th>
      <th className={styles.table__cell__header}>土</th>
    </tr>
  )
}

export default ScheduleCalendarHeaderRow
